import { Component } from '@angular/core';

@Component({
  selector: 'app-confirm-bookmark-delete.dialog',
  templateUrl: './confirm-bookmark-delete.dialog.component.html',
  styleUrl: './confirm-bookmark-delete.dialog.component.scss'
})
export class ConfirmBookmarkDeleteDialogComponent {

}
